"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CodeLeaf = void 0;
var _react = _interopRequireDefault(require("react"));
var _cn = require("@udecode/cn");
var _plateCommon = require("@udecode/plate-common");
var _jsxRuntime = require("react/jsx-runtime");
var CodeLeaf = exports.CodeLeaf = (0, _cn.withRef)(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, ["children", "className"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_plateCommon.PlateLeaf, _objectSpread({
    ref: ref,
    asChild: true,
    className: (0, _cn.cn)('whitespace-pre-wrap rounded-md bg-muted px-[0.3em] py-[0.2em] font-mono text-sm', className)
  }, props, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("code", {
      children: children
    })
  }));
});